import { render, staticRenderFns } from "./LHRTertimbangSection.vue?vue&type=template&id=568868bf&scoped=true"
import script from "./LHRTertimbangSection.vue?vue&type=script&lang=js"
export * from "./LHRTertimbangSection.vue?vue&type=script&lang=js"
import style0 from "./LHRTertimbangSection.vue?vue&type=style&index=0&id=568868bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568868bf",
  null
  
)

export default component.exports